<template>
  <div class="ai-mult-picker">
    <div class="header">
      <div class="left" @click="handleCancel">取消</div>
      <div class="title"></div>
      <div class="right" @click="handleConfirm">确认</div>
    </div>
    <div class="cut-line"></div>
    <div class="content">
      <template v-for="(item, index) in items" :key="item.value">
        <van-checkbox
          v-model="checkedvalues[index]"
          checked-color="#7a52f4"
          icon-size="16px"
          :name="item.value"
          >{{ item.label }}</van-checkbox
        >
        <div class="sub-cut-line"></div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  },
  value: {
    type: Array,
    default: () => []
  },
  show: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '标题'
  }
})
const emit = defineEmits(['update:value', 'update:show', 'close', 'change'])

const checkedvalues = ref([])

const handleCancel = () => {
  emit('update:show', false)
}

const handleConfirm = () => {
  const arr = []
  props.items.forEach((item, index) => {
    if (checkedvalues.value[index]) {
      arr.push(item.value) // 更新的时候，把对应下标对应的值返回
    }
  })
  emit('update:value', arr)
  emit('change', arr)
  emit('update:show', false)
}

onMounted(() => {
  props.items.forEach((item, index) => {
    if (
      props.value.find((i) => i === item.value) ||
      props.value.find((i) => i === item.value) === 0
    ) {
      checkedvalues.value[index] = true // 获取的时候 对应下标选中
    }
  })
  console.log(props.value)
})
</script>

<style lang="scss" scoped>
.ai-mult-picker {
  height: 450px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .header {
    flex: 0 0 auto;
    height: 48px;
    margin: 0 16px;
    padding: 10px 0;
    display: flex;
    align-items: center;
    .left {
      flex: 0 0 60px;
      text-align: left;
      font-size: 14px;
      color: #969799;
    }
    .title {
      flex: 1;
      text-align: center;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      color: #323233;
    }
    .right {
      flex: 0 0 60px;
      text-align: right;
      font-size: 14px;
      color: #7a52f4;
    }
  }
  .cut-line {
    flex: 0 0 auto;
    margin: 0 16px;
    height: 1px;
    background-color: #e5e5e5;
    transform: scaleY(0.5);
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    overflow-y: scroll;
    .item {
      padding: 16px;
      font-size: 14px;
      color: #323233;
    }

    .sub-cut-line {
      height: 1px;
      background-color: #e5e5e5;
      transform: scaleY(0.5);
    }
    :deep(.van-checkbox) {
      padding: 12px;
    }
  }
}
</style>
